class CategoryNominees{
    constructor(id, category, oscarYear, nominees){
        this.id = id;
        this.category = category;
        this.oscarYear = oscarYear;
        this.nominees = nominees;
    }
}

export default CategoryNominees;